module.exports = __webpack_public_path__ + "media/icons/map_icon_white-afae9758.svg";